import React from 'react';
import Icon, {IconSize} from '../../../ui/Icon/Icon';
import {GenericIconName} from '../../../ui/Icon/IconName';
import {
  ModalText,
  ModalTitle,
  SuccessIconWrapper,
} from '../ProductReview.styled';
import {useProductReviewTranslations} from '../context/ProductReviewTranslationsProvider';

const SuccessMessage: React.FC = () => {
  const {successModalTitle, successModalDescription} =
    useProductReviewTranslations();
  return (
    <>
      <SuccessIconWrapper>
        <Icon asset={GenericIconName.IcSuccess} size={IconSize.M} />
      </SuccessIconWrapper>
      <ModalTitle data-testid="review-modalTitle-voted">
        {successModalTitle}
      </ModalTitle>
      <ModalText data-testid="review-modalDesc-success">
        {successModalDescription}
      </ModalText>
    </>
  );
};

export default SuccessMessage;
